export const OFFICIAL_ADMIN_PROFILE = Object.freeze({
  uid: "mfp-official-admin",
  name: "MyFarmingPal Admin",
  displayName: "MyFarmingPal Admin",
  photo: "/brand-logo-square.png",
  profilePicture: "/brand-logo-square.png",
  type: "admin",
  role: "admin",
  official: true,
});

export const isOfficialAdminMessage = (message = {}, conversation = {}) => {
  if (
    message.messageType === "admin_message" ||
    message.official === true ||
    message.senderRole === "admin"
  ) {
    return true;
  }

  const participantInfo =
    conversation.participantsInfo?.[message.senderId] || {};

  return (
    (conversation.isAdminConversation === true ||
      conversation.adminMessageThread === true ||
      conversation.official === true) &&
    (participantInfo.type === "admin" ||
      participantInfo.role === "admin" ||
      participantInfo.official === true)
  );
};

export const getMessageSenderProfile = ({
  message,
  conversation,
  senderProfile,
}) =>
  isOfficialAdminMessage(message, conversation)
    ? OFFICIAL_ADMIN_PROFILE
    : senderProfile;
